'use strict';

var React = require('react');
var component$1 = require('../Drawer/component.js');
var index = require('../Flex/index.js');
var component = require('../Icon/component.js');
require('../Tooltip/component.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const HeaderNavBarTablet = React.forwardRef(({ logo, items, search, settings, ...props }, ref) => {
    const [isOpened, setOpened] = React.useState(false);
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(styles.Styled.Container, { ...props, ref: ref },
            React__default.default.createElement(index.Flex.Row, { space: "m", justifyContent: "space-between" },
                React__default.default.createElement(styles.Styled.LogoContainer, null, logo),
                React__default.default.createElement(index.Flex.Row, { space: "m" },
                    React__default.default.createElement("div", null, search),
                    React__default.default.createElement(styles.Styled.Burger, { role: "button", onClick: () => setOpened(true) },
                        React__default.default.createElement(component.Icon, { name: "menu-filled" }))))),
        React__default.default.createElement(component$1.Drawer, { isOpened: isOpened, onOpenedChange: setOpened, position: "right", header: React__default.default.createElement(styles.Styled.LogoContainer, null, logo) },
            items,
            settings)));
});

exports.HeaderNavBarTablet = HeaderNavBarTablet;
//# sourceMappingURL=Tablet.js.map
